import { render, staticRenderFns } from "./Preferences.vue?vue&type=template&id=01f9b8d7&scoped=true"
import script from "./Preferences.vue?vue&type=script&lang=js"
export * from "./Preferences.vue?vue&type=script&lang=js"
import style0 from "./Preferences.vue?vue&type=style&index=0&id=01f9b8d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f9b8d7",
  null
  
)

export default component.exports